export const OperacionLCTCCuentaFields = {
    CodClienteTipo: 'codOperacionLCTCClienteTipo',
    DescClienteTipo: 'descClienteTipo',
    CodClienteSubTipo: 'codOperacionLCTCClienteSubTipo',
    DescClienteSubTipo: 'descClienteSubTipo',
    LimiteConcertacion: 'limiteConcertacion',
    LimiteLiquidacionDVP: 'limiteLiquidacionDVP',
    LimiteLiquidacionFOP: 'limiteLiquidacionFOP',
} as const

export const OperacionLCTCFields = {
    CodOperacionLCTC: 'codOperacionLCTC',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodUnidadNegocio: 'codUnidadNegocio',
    DescUnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    DescSectorComercial: 'descSectorComercial',
    FechaSolicitud: 'fechaSolicitud',
    FechaVencimiento: 'fechaVencimiento',
    CodEstado: 'codEstado',
    DescEstado: 'descEstado',
    Observaciones: 'observaciones',

    Cuentas: 'cuentas',

    FechaAprobacion: 'fechaAprobacion',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    NombreUsuarioUltMod: 'nombreUsuarioUltMod',
    ApellidoUsuarioUltMod: 'apellidoUsuarioUltMod',
    MailUsuarioUltMod: 'mailUsuarioUltMod',
    EstadoFinalizado: 'estadoFinalizado',
    IdMensaje: 'idMensaje',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',
    Monto: 'monto',

} as const

export const OperacionLCTCCuentaLimiteFields = {
    CodGrupo: 'codGrupo',
    DescGrupo: 'descGrupo',
    LimiteConcertacion: 'limiteConcertacion',
    LimiteLiquidacionDVP: 'limiteLiquidacionDVP',
    LimiteLiquidacionFOP: 'limiteLiquidacionFOP',
    FechaAccion: 'fechaAccion',
    Etapa: 'descEtapa',
    OrdenCliente: 'ordenClienteTipo',
    OrdenSubCliente: 'ordenClienteSubTipo',
    UnidadNegocio: 'unidadNegocio',
    ClienteTipo: 'clienteTipo',
    ClienteSubTipo: 'clienteSubTipo',
    PermiteModificar: 'permiteModificar',
} as const;


export const OperacionLCTCCacheFields = {
    Orden: 'orden'
} as const;

export const OperacionLCTCLimiteAprobadoFields = {
    CodPais: 'codPais',
    CodSistema: 'codSistema',
    CodClienteTipo: 'codClienteTipo',
    DescClienteTipo: 'descClienteTipo',
    CodClienteSubTipo: 'codClienteSubTipo',
    DescClienteSubTipo: 'descClienteSubTipo',
    LimiteConcertacionFinal: 'limiteConcertacionFinal',
    LimiteLiquidacionDVPFinal: 'limiteLiquidacionDVPFinal',
    LimiteLiquidacionFOPFinal: 'limiteLiquidacionFOPFinal',
    Activo: 'activo',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    IdMensaje: 'idMensaje',
    FechaAprobacion: 'fechaAprobacion',
    UsuarioUltMod: 'usuarioUltMod',
    NombreSistemaPrincipal: 'nombreSistemaPrincipal',
    CodSistemaPrincipal: 'codSistemaPrincipal',
    CodUnidadNegocio: 'codUnidadNegocio'
} as const;

export const OperacionLCTCLimitesAprobadosUnidadNegocioFields = {
    CodUnidadNegocio: 'codUnidadNegocio',
    DescUnidadNegocio: 'descUnidadNegocio',
    ListaLimites: 'limites'
} as const;

export const OperacionLCTCLimitesAprobadosPaisFields = {
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    FechaUltMod: 'fechaUltMod',
    UsuarioUltMod: 'usuarioUltMod',
    IdMensaje: 'idMensaje',
    FechaAprobacion: 'fechaAprobacion',
    ListaUnidadesNegocio: 'unidadesNegocio'
} as const;

export const OperacionLCTCRelacionFields = {
    CodSectorComercial: 'codSectorComercial',
    CodClienteTipo: 'codClienteTipo',
    CodClienteSubTipo: 'codClienteSubTipo',
    DescClienteTipo: 'descClienteTipo',
    DescClienteSubTipo: 'descClienteSubTipo',
} as const;



export const OperacionLCTCUnidadNegocioFields = {
    CodUnidadNegocio: 'codUnidadNegocio',
} as const;

export const OperacionLCTCSectorComercialFields = {
    CodUnidadNegocio: 'codUnidadNegocio',
    CodSectorComercial: 'codSectorComercial'
} as const;